export const CompleteDocumentSignatureActionDefinition = {
  ActionDefinitionId: 'Internal.CompleteDocumentSignature',
  FieldId_SignatureRequestId: '0146a4a0-8103-431c-bc7a-08a29834437f'
} as const;